import { Injectable, OnDestroy } from '@angular/core';
import { DynamicComponentService } from '@draeger-academy/common';

import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

import { GenericModalComponent } from '../generic-modal.component';
import { IGenericModalOptions } from './../igeneric-modal-options';
import { GenericModalBroadcasterService } from './generic-modal-broadcaster.service';

@Injectable({
    providedIn: 'root'
})
export class GenericModalService implements OnDestroy {
    private _loadedTemplate: Map<string, any> = new Map();
    private _latestID: string = null;

    constructor(private _dynamicComponentService: DynamicComponentService, private _gmb: GenericModalBroadcasterService) {
        this._gmb.onClose().subscribe((data) => {
            this.close(data);
        });
    }

    ngOnDestroy() {
        this._loadedTemplate.forEach((value, key) => this._dynamicComponentService.removeContainerElement(key));
    }

    public onClose(uniqueID: string): Observable<boolean> {
        return this._gmb.onClose().pipe(filter((_id) => _id === uniqueID));
    }

    public getLatestID(): string {
        return this._latestID;
    }

    public open(
        uniqueID?: string,
        type = 'voice',
        isWarning?: boolean,
        additionalClass?: string,
        isCookie?: boolean,
        isLogin?: boolean
        ) {
        const _id = this._getID(uniqueID);
        const _refObject = this._loadedTemplate.get(_id);
        setTimeout(() =>
            this._openModal(_id, _refObject.template, _refObject.options, true, isWarning, additionalClass, isCookie, isLogin)
        ); // refactor not static true
        const bodyTag = document.body;
        bodyTag.classList.add('overflow-hidden');
    }

    public close(uniqueID?: string, removeAll = false): any {
        const _id = this._getID(uniqueID);

        this._dynamicComponentService.removeContainerElement(_id);
        if (removeAll) {
            this._loadedTemplate.delete(_id);
        }
        this._latestID = null;
        const bodyTag = document.body;
        bodyTag.classList.remove('overflow-hidden');
    }

    public create(template: any, options?: IGenericModalOptions): string {
        const _uniqueID = this._genUniqueId();
        this._loadedTemplate.set(_uniqueID, { template: template, options: options });
        return _uniqueID;
    }

    public get(uniqueID: string): any {
        return this._loadedTemplate.get(uniqueID);
    }

    public latest(): any {
        return this._loadedTemplate.get(this._latestID);
    }

    private _openModal(
        uniqueID: string,
        template,
        options: IGenericModalOptions,
        isCloseable = false,
        isWarning = false,
        additionalClass = '',
        isCookie = false,
        isLogin = false
    ) {
        let _nativeComponentRef = this._dynamicComponentService.get<GenericModalComponent>(uniqueID);
        if (!_nativeComponentRef) {
            _nativeComponentRef = this._dynamicComponentService.createContainer<GenericModalComponent>(uniqueID, GenericModalComponent);
            _nativeComponentRef._ref.instance.template = template;
            _nativeComponentRef._ref.instance.additionalClass = additionalClass;
            _nativeComponentRef._ref.instance.options = options;
            _nativeComponentRef._ref.instance.isCloseable = isCloseable;
            _nativeComponentRef._ref.instance.isWarning = isWarning;
            _nativeComponentRef._ref.instance.isCookie = isCookie;
            _nativeComponentRef._ref.instance.isLogin = isLogin;
            _nativeComponentRef._ref.instance.modalID = uniqueID;
        }
    }

    private _genUniqueId(): string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = (Math.random() * 16) | 0,
                v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }

    private _getID(uniqueID?: string): string {
        let id;
        if (uniqueID) {
            id = uniqueID;
        } else if (this._latestID) {
            id = this._latestID;
        } else {
            throw new Error('No ID to open options.');
        }
        return id;
    }
}
